module.exports = __webpack_public_path__ + "img/plus-round.269a7e61.svg";